<template>
  <div style="height: 100%">
    <ViewItem class="myViewItem" label="授权系统">
      <Select transfer placeholder="请选择授权系统" @on-change="appSelectChange" >
        <Option v-for="(item, index) in treeDataObj.app" :key="index" :label="item.title" :value="item.id"></Option>
      </Select>
    </ViewItem>
    <div class="permissionMain" style="height: 100%">
      <SetPermission
        class="serPermissions"
        v-for="(item, index) in listData"
        :key="index"
        :ref="item.type"
        :treeData="treeDataObj[item.type]"
        :title="item.title"
        :isSelect="item.isSelect"
        :hasSearch="item.hasSearch"
        :hasSubmit="item.hasSubmit"
        :type="item.type"
        :selectAll="item.selectAll"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        @on-select-submit="onSelectSubmit"
        @on-search-change="onSearchChange"
        @on-select-all="onSelectAll"
      />
    </div>
    <SelectDepartment v-if="selectDepartmentVisible" :type="currentDepartmentType" :operableIds="operableIds" :visible.sync="selectDepartmentVisible" :selectList="departmentSelectList" @on-submit="selectDepartmentSubmit" :originData="departmentUseOriginData" />
  </div>
</template>
<script>
import _ from 'lodash';
import util from '@/assets/js/util';
import { getOwnAppInAuthUserListApi, getRoleAppRowRuleAPi, submitOrgUserRoleApi } from '@/api/userManage';
import SetPermission from '@/components/custom-setPermission';
import SelectDepartment from './SelectDepartmentForRole.vue';
import { getConfigByType, permissionRoleConfig } from './componentsConfig';

const customDepartmentID = 'custom_department';
export default {
  components: { SetPermission, SelectDepartment },
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentAppId: '',
      currentMenuId: '',
      currentRoleId: '',
      listData: [
        {
          title: '角色',
          type: 'role',
          isSelect: true,
          hasSearch: true,
          selectAll: true
        },
        {
          title: '系统行数据权限',
          type: 'systemRow',
          hasSubmit: true,
          isSelect: true,
          selectAll: true
        },
        {
          title: '菜单权限',
          type: 'menu',
          isSelect: true,
          hasSearch: true
        },
        {
          title: '页面控件权限',
          type: 'component',
          isSelect: true,
          hasSubmit: true
        },
        {
          title: '页面列数据权限',
          type: 'col',
          isSelect: true,
          hasSubmit: true
        },
        {
          title: '页面行数据权限',
          type: 'row',
          isSelect: true,
          hasSubmit: true
        }
      ],
      treeDataObj: {
        role: [],
        app: [],
        systemRow: [],
        menu: [],
        component: [],
        col: [],
        row: []
      },
      changeSelectIdsMap: {
        role: [],
        app: [],
        systemRow: [],
        menu: [],
        component: [],
        col: [],
        row: []
      },
      searchUseData: {
        rule: [],
        menu: []
      },
      selectIds: {
        menu: [],
        role: [],
        department: []
      },
      // 保存原始数据
      originData: {
        systemRow: [],
        row: []
      },
      // 保存当前有权限选的list
      operableIds: [],
      selectDepartmentVisible: false, // 选择部门弹框展示隐藏
      departmentSelectList: [], // 部门选择列表
      currentDepartmentType: '' // 部门弹框所需类型 row，systemRow
    };
  },
  computed: {
    departmentUseOriginData () {
      return (this.originData[this.currentDepartmentType] || []).find(i => i.id === customDepartmentID) || {};
    }
  },
  methods: {
    // 系统选项下拉框的变化事件
    async appSelectChange (value) {
      if (this.currentAppId) {
        await this.systemChange();
      }
      this.originData.row = [];
      this.currentAppId = value;
      // 获取系统行数据权限
      if (!value) {
        this.treeDataObj = { ...this.treeDataObj };
        return;
      }
      this.clearByType(['role', 'systemRow', 'menu', 'component', 'col', 'row']);
      this.getRoleList(value);
    },
    // 获取角色列表
    getRoleList(appId) {
      const data = { userId: this.userId, appId };
      this.$ajax.post('/v1/orgUserAuth/orgUserAllRoles', data, { noUseGlobalLoading: true }).then(res => {
        const { code, data } = res.data;
        const roleSelectIds = [];
        if (code == 200) {
          const roleData = data.map(item => {
            if (item.authStatus) {
              roleSelectIds.push(item.roleId);
            }
            return {
              id: item.roleId,
              title: item.roleName,
              needSelected: true,
              checked: !!item.authStatus
            };
          });
          this.treeDataObj = { ...this.treeDataObj, role: roleData };
          this.searchUseData = {
            ...this.searchUseData,
            role: _.cloneDeep(roleData)
          };
          this.selectIds = {
            ...this.selectIds,
            role: [...new Set(roleSelectIds)]
          };
        }
      });
    },
    // 清空
    clearByType(clearType) {
      clearType.forEach(item => {
        // 清空所有的数据
        this.treeDataObj = {
          ...this.treeDataObj,
          [item]: []
        };
        // 清除更改过的数据
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [item]: []
        };
      });
    },
    // 获取系统信息
    getAppInfo(id, type) {
      // 获取app列表
      this.$ajax(`/v1/role/roleAllApps/${id}`, { noUseGlobalLoading: true }).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          const appAuthorization = data.map(item => ({
            id: item.id,
            title: item.name,
            needSelected: true
          }));
          this.treeDataObj = { ...this.treeDataObj, app: appAuthorization };
        }
      });
    },
    // 获取 菜单信息
    getMenuInfo(appId, type) {
      const data = {
        appId: this.currentAppId,
        userId: this.userId,
        roleId: this.currentRoleId
      };
      const nextType = type[0];
      this.$ajax.post('/v1/orgUserAuth/orgUserRoleFuncMenu', data, { noUseGlobalLoading: true }).then(res => {
        const { data, code } = res.data;
        const menuSelectIds = [];
        if (code == 200) {
          const originMenuTreeData = data.map(item => {
            const {
              funcMenuId,
              parentMenuId,
              menuName,
              authStatus,
              ...rest
            } = item;
            if (authStatus) {
              menuSelectIds.push(funcMenuId);
            }
            return {
              ...rest,
              title: menuName,
              id: funcMenuId,
              pid: !parentMenuId || parentMenuId == '0' ? null : parentMenuId,
              needSelected: true,
              checked: !!authStatus
            };
          });
          const menuTreeData = util.getMenuTree(originMenuTreeData);
          this.treeDataObj = {
            ...this.treeDataObj,
            [nextType]: menuTreeData
          };
          this.searchUseData = {
            ...this.searchUseData,
            menu: _.cloneDeep(menuTreeData)
          };
          this.selectIds = {
            ...this.selectIds,
            menu: [...new Set(menuSelectIds)]
          };
        }
      });
    },
    // 获取列，行，组件权限
    getOtherPermission(id, type) {
      Promise.all([
        this.getColData(id),
        this.getRowData(id),
        this.getComponentData(id)
      ]).then(([res1, res2, res3]) => {
        const colData = res1.map(item1 => {
          const { authStatus, ruleName, ...rest } = item1;
          return {
            ...rest,
            checked: !!authStatus,
            title: ruleName
          };
        });
        const rowData = res2.map(item2 => {
          const { authStatus, ruleName, ...rest } = item2;
          return {
            ...rest,
            checked: !!authStatus,
            title: ruleName,
            allDepartRelList: [...item2.selDepartRelList || []],
            render: (h, { data }) => {
              return h('span', { style: { color: item2.id.indexOf('dar_') >= 0 ? 'red' : '' } }, data.title);
            }
          };
        });
        this.originData.row = JSON.parse(JSON.stringify(rowData));
        const componentData = res3.map(item3 => {
          const { authStatus, componentName, ...rest } = item3;
          return {
            ...rest,
            checked: !!authStatus,
            title: componentName
          };
        });
        this.treeDataObj = {
          ...this.treeDataObj,
          component: componentData,
          row: rowData,
          col: colData
        };
      });
    },
    // 获取列权限
    getColData(menuId) {
      const data = {
        funMenuId: menuId,
        userId: this.userId,
        roleId: this.currentRoleId
      };
      return new Promise(resolve => {
        this.$ajax
          .post('/v1/orgUserAuth/orgUserRoleDataColRule', data, { noUseGlobalLoading: true })
          .then(res => {
            const { code, data } = res.data;
            if (code == 200) {
              resolve(data);
            }
          });
      });
    },
    // 获取行权限
    getRowData(menuId) {
      const data = {
        funMenuId: menuId,
        userId: this.userId,
        roleId: this.currentRoleId
      };
      return new Promise(resolve => {
        this.$ajax
          .post('/v1/orgUserAuth/orgUserRoleDataRowRule', data, { noUseGlobalLoading: true })
          .then(res => {
            const { code, data } = res.data;
            if (code == 200) {
              if (Array.isArray(data)) {
                data.forEach((item, index) => {
                  item.needSelected = true;
                  item.selected = false;
                  const newSelctedList = [];
                  if (item.id === customDepartmentID) {
                    // 自定义部门不允许勾选
                    item.disableCheckbox = true;
                    const obj = item.selDepartRelList ? JSON.parse(item.selDepartRelList) : {};
                    const operableIds = _.cloneDeep(item.selRoleDepartRelList ? JSON.parse(item.selRoleDepartRelList) : []);
                    const unSelectedList = obj.excludes || [];
                    // 变不了数字，用新数组处理,到时候看下原因
                    for (let i = 0; i < operableIds.length; i++) {
                      const item = operableIds[i];
                      const temp = parseInt(item);
                      newSelctedList.push(temp);
                    }
                    for (let i = 0; i < unSelectedList.length; i++) {
                      const item = unSelectedList[i];
                      const index = newSelctedList.findIndex(e => e == item);
                      if (index > -1) {
                        newSelctedList.splice(index, 1);
                      }
                    }
                    // 如果是没有勾选行自定义部门的 把所有的当作排他处理
                    if (item.authStatus === 0) {
                      newSelctedList.splice(0, newSelctedList.length);
                    }
                    item.operableIds = operableIds;
                  }
                  item.selDepartRelList = [...newSelctedList || []];
                });
              }
              resolve(data);
            }
          });
      });
    },
    // 获取组件权限
    getComponentData(menuId) {
      const data = {
        roleId: this.currentRoleId,
        funMenuId: menuId,
        userId: this.userId
      };
      return new Promise(resolve => {
        this.$ajax
          .post('/v1/orgUserAuth/orgUserRolePageComponent', data, { noUseGlobalLoading: true })
          .then(res => {
            const { code, data } = res.data;
            if (code == 200) {
              resolve(data);
            }
          });
      });
    },
    // 保存角色权限
    submitRole(type) {
      return new Promise(resolve => {
        const data = this.changeSelectIdsMap[type];
        const roleAuths = data.map(item => ({
          id: item.id,
          authStatus: item.checked ? 1 : 0
        }));
        this.$ajax
          .post('/v1/orgUserAuth/editOrgUserRoles', {
            roleAuths,
            userId: this.userId
          })
          .then(res => {
            const { code } = res.data;
            if (code == 200) {
              this.changeSelectIdsMap = {
                ...this.changeSelectIdsMap,
                [type]: []
              };
              resolve(true);
            }
            resolve(false);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    // 保存菜单控件
    submitMenu(type) {
      return new Promise(resolve => {
        const data = this.changeSelectIdsMap[type];
        if (data.length == 0) {
          return this.$Message.error('未变化任何数据');
        }
        const funcMenuAuths = data.map(item => ({
          id: item.id,
          authStatus: item.checked ? 1 : 0
        }));
        this.$ajax
          .post('/v1/orgUserAuth/editOrgUserRoleFuncMenu', {
            funcMenuAuths,
            roleId: this.currentRoleId,
            appId: this.currentAppId,
            userId: this.userId
          })
          .then(res => {
            const { code } = res.data;
            if (code == 200) {
              this.changeSelectIdsMap = {
                ...this.changeSelectIdsMap,
                [type]: []
              };
              resolve(true);
            }
          });
      });
    },
    // 控件、行列权限ajax 请求
    ajaxOthers(type) {
      return new Promise(resolve => {
        const data = this.changeSelectIdsMap[type];
        const { submitKey, submitUrl } = permissionRoleConfig[type];
        let auths = [];
        if (type === 'row') {
          const appRowAuths = this.treeDataObj.row.map(i => {
            return {
              authStatus: i.checked ? 1 : 0,
              delSelDepartRelList: i.delSelDepartRelList,
              selDepartRelList: i.selDepartRelList,
              id: i.id
            };
          });
          auths = [...appRowAuths];
        } else {
          auths = data.map(item => ({
            id: item.id,
            authStatus: item.checked ? 1 : 0
          }));
        }
        this.$ajax
          .post(submitUrl, {
            [submitKey]: auths,
            funcMenuId: this.currentMenuId,
            roleId: this.currentRoleId,
            userId: this.userId
          })
          .then(res => {
            const { code } = res.data;
            if (code == 200) {
              this.changeSelectIdsMap = {
                ...this.changeSelectIdsMap,
                [type]: []
              };
              if (type == 'row') {
                this.originData.row = JSON.parse(JSON.stringify(this.treeDataObj.row));
              }
              resolve();
            }
          });
      });
    },
    // 保存 行列 组件权限
    submitOthers(type) {
      const data = this.changeSelectIdsMap[type];
      // 如果是行权限保存，变化了部门也是变化
      if (type == 'row') {
        if (this.changeSelectIdsMap[type].length === 0 && !this.rowIsChange(this.originData.row, this.treeDataObj.row)) {
          return this.$Message.error('未变化任何数据');
        }
      } else {
        if (data.length == 0) {
          return this.$Message.error('未变化任何数据');
        }
      }
      const menuChangeSelect = this.changeSelectIdsMap.menu;
      if (menuChangeSelect.length > 0) {
        // 这里面判断较多
        this.submitMenu('menu').then(res => {
          if (!res) return false;
          this.ajaxOthers(type);
        });
      } else {
        this.ajaxOthers(type);
      }
    },
    // 点击节点改变
    onSelectChange({ type, selectItem }) {
      const { id } = selectItem;
      if (type === 'menu') {
        this.menuTreeChange(selectItem);
        return;
      }
      // 系统行数据权限
      if (['systemRow', 'row'].includes(type)) {
        this.currentDepartmentType = type;
        this.selectDepartmentVisible = selectItem.id === customDepartmentID;
        this.departmentSelectList = selectItem.allDepartRelList ? selectItem.allDepartRelList : [];
        this.operableIds = selectItem.operableIds || [];
        selectItem.selected = false;
        return;
      }
      if (type === 'role') {
        if (!selectItem.checked) return;
        this.handleRoleChange(selectItem);
        return;
      }
      const { getNextItem: method, nextType, saveIdName, clearType } = permissionRoleConfig[type] || {};
      const saveIdList = ['menu'];
      if (saveIdList.includes(type)) {
        this[saveIdName] = id;
      }
      this.clearByType(clearType);
      if (['role', 'menu'].includes(type) && !selectItem.checked) {
        return false;
      }
      if (type !== 'row') {
        this[method](id, nextType);
      }
    },
    async handleRoleChange (selectItem) {
      if (this.currentRoleId) {
        await this.systemChange();
      }
      const { clearType } = permissionRoleConfig.role;
      this.clearByType(clearType);
      this.originData.row = [];
      this.originData.systemRow = [];
      // 获取 系统行数据权限
      // 获取 菜单权限
      this.currentRoleId = selectItem.id;
      this.getMenuInfo(this.currentAppId, ['menu']);
      this.getRoleAppRowRule({ appId: this.currentAppId, userId: this.userId, roleId: this.currentRoleId });
    },
    getRoleAppRowRule (body) {
      getRoleAppRowRuleAPi(body).then(res => {
        const { code, data } = res.data;
        if (code !== 200) return;
        const systemRow = data.map(i => {
          const obj = JSON.parse(i.selDepartRelList || '{}');
          const includes = [...obj.includes || []];
          const excludes = [...obj.excludes || []];
          const operableIds = [...JSON.parse(i.selRoleDepartRelList || '[]')];
          const selDepartRelList = [];
          const unSelectedList = [...excludes || []];
          // 变不了数字，用新数组处理,到时候看下原因
          for (let i = 0; i < operableIds.length; i++) {
            const item = operableIds[i];
            const temp = parseInt(item);
            selDepartRelList.push(temp);
          }
          for (let i = 0; i < unSelectedList.length; i++) {
            const item = unSelectedList[i];
            const index = selDepartRelList.findIndex(e => e == item);
            if (index > -1) {
              selDepartRelList.splice(index, 1);
            }
          }
          // 如果是没有勾选行自定义部门的 把所有的当作排他处理
          if (i.authStatus === 0) {
            selDepartRelList.splice(0, selDepartRelList.length);
          }
          return {
            ...i,
            disableCheckbox: i.id === customDepartmentID,
            checked: !!i.authStatus,
            title: i.ruleName,
            needSelected: true,
            selDepartRelList,
            operableIds,
            allDepartRelList: [...selDepartRelList]
          };
        });
        this.originData.systemRow = JSON.parse(JSON.stringify(systemRow));
        this.treeDataObj = { ...this.treeDataObj, systemRow: JSON.parse(JSON.stringify(systemRow)) };
      });
    },
    // 设置父节点选中状态
    setParentSelect({ type, changeItem, isDelete }) {
      /*
        首先先把父节点的checked 置为 true，如果有父节点的话，在递归次函数，把父节点的 checked 改为 true
        这里面是一层一层往上找节点
       */
      // 先吧当前节点的checked 改为 true
      // 再把父节点递归
      const tree = this.treeDataObj[type];
      let changeData = [...this.changeSelectIdsMap[type]];
      this.selectIds = {
        ...this.selectIds,
        [type]: [...this.selectIds[type], changeItem.id]
      };
      const ids = changeData.map(item => item.id);
      const flat = util.treeChangeFlat(tree).map(item => {
        const { parentNode, children, ...rest } = item;
        return {
          ...rest
        };
      });
      flat.forEach(item => {
        if (item.id == changeItem.id) {
          item.checked = true;
          if (ids.includes(item.id)) {
            changeData = changeData.filter(i => i.id != item.id);
          } else {
            changeData.push(item);
          }
        }
      });
      const data = util.getMenuTree(flat);
      this.treeDataObj = { ...this.treeDataObj, [type]: data };
      this.changeSelectIdsMap = {
        ...this.changeSelectIdsMap,
        [type]: changeData
      };
      if (changeItem.parentNode && !changeItem.parentNode.checked) {
        this.setParentSelect({
          type,
          changeItem: changeItem.parentNode,
          isDelete: true
        });
      }
    },
    setParentStatus({ type, changeItem, isDelete, idListName, idName }) {
      const { children } = changeItem;
      if (children && children.length) {
        if (children.every(item => !item.checked)) {
          changeItem.checked = false;
          this[idListName] = [...this[idListName].filter(i => i !== changeItem[idName])];
        } else {
          changeItem.checked = true;
          this[idListName] = [...this[idListName], changeItem[idName]];
        }
      }
      if (changeItem.pid && changeItem.parentNode) {
        this.setParentStatus({ changeItem: changeItem.parentNode, isDelete, idName, idListName });
      }
    },
    // 删除子节点选中状态
    deleteChildrenNode({ type, children, isDelete }) {
      children.forEach(item => {
        let changeData = [...this.changeSelectIdsMap[type]];
        const ids = changeData.map(item => item.id);
        if (item.checked) {
          if (item.id == this.currentMenuId) {
            // 此时把控件、行、列、权限等里面的数据给清空
            this.clearComRowColChecked();
          }
          // 此时把选择关闭
          item.checked = false;
          if (ids.includes(item.id)) {
            // 此时存在，就删除data里面对应的数据
            changeData = changeData.filter(i => i.id != item.id);
          } else {
            // 此时加上对应的数据
            changeData.push(item);
          }
        }
        if (this.selectIds[type]) {
          const selectIds = this.selectIds[type].filter(id => id != item.id);
          this.selectIds = { ...this.selectIds, [type]: selectIds };
        }
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [type]: changeData
        };
        if (item.children && item.children.length > 0) {
          this.deleteChildrenNode({
            type,
            children: item.children,
            isDelete: true
          });
        }
      });
    },
    changeChildrenNode({ type, children, isDelete, idListName, idName }) {
      children.forEach(item => {
        if (item.checked) {
          if (item.id == this.currentMenuId) {
            // 此时把控件、行、列权限里面的数据给清空选择
            this.clearComRowColChecked();
          }
        }
        if (isDelete) {
          this[idListName] = [...this[idListName].filter(i => i !== item[idName])];
        } else {
          this[idListName] = [...this[idListName], item[idName]];
        }
        item.checked = !isDelete;
        if (item.children && item.children.length > 0) {
          this.changeChildrenNode({
            type,
            children: item.children,
            isDelete,
            idListName,
            idName
          });
        }
      });
    },
    // 选择框选中不选中出发
    onCheckChange({ type, changeItem, isDelete, dtClear = false }) {
      const { checkChangeMehods } = permissionRoleConfig[type];
      if (type !== 'department') {
        if (type == 'role') {
          this[checkChangeMehods](type, changeItem);
          return;
        }
        let changeData = [...this.changeSelectIdsMap[type]];
        const ids = changeData.map(item => item.id);
        // 如果是有值的话，说明，已经更改过对应的数据，所以，把之前的数据给干掉就可以了
        // 如果ids 里面没有现在选择过的值的话，就push进去，证明这个要搞一下
        if (ids.includes(changeItem.id)) {
        // 此时存在，就删除data里面对应的数据
          changeData = changeData.filter(item => item.id != changeItem.id);
        } else {
        // 此时加上对应的数据
          changeData.push(changeItem);
        }
        if (this.selectIds[type]) {
          if (isDelete) {
            const selectIds = this.selectIds[type].filter(
              id => id != changeItem.id
            );
            this.selectIds = { ...this.selectIds, [type]: selectIds };
          } else {
            this.selectIds = {
              ...this.selectIds,
              [type]: [...this.selectIds[type], changeItem.id]
            };
          }
        }
        // 给变更过的ids赋值
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [type]: changeData
        };
        // 如果有pid 的话，就判断是否是选中状态
        if (changeItem.pid && changeItem.parentNode && !isDelete) {
        // 此时有pid 并且是选中状态 就把父的选中
          if (!changeItem.parentNode.checked) {
          // 在此处把父节点的给选中
            this.setParentSelect({
              type,
              changeItem: changeItem.parentNode,
              isDelete: false
            });
          }
        }
        if (isDelete && changeItem.id === this.currentMenuId && !dtClear) {
        // 此时把控件、行、列权限里面的数据给清空选择
          this.clearComRowColChecked();
        }
        // 如果是有子节点的话，并且选择删除的时候，把子节点的给取消掉
        if (isDelete && changeItem.children && changeItem.children.length > 0) {
          this.deleteChildrenNode({
            type,
            children: changeItem.children,
            isDelete: true
          });
        }
        // 如果是选择菜单的时候,就把对应的数据给选择上，然后提交
        if (type == 'menu') {
          this[checkChangeMehods](type, changeItem, dtClear);
        }
      }
      // 如果是数据非菜单权限的话，就在此调用一下这个方法
      if (!['menu', 'app', 'role'].includes(type)) {
        // 选中数据也得更改
        // 将对应的数据给菜单数据选中
        const currentMenu = util.getCurrentData(
          this.treeDataObj.menu,
          this.currentMenuId
        );
        if (!currentMenu.checked) {
          currentMenu.checked = true;
          this.setParentSelect({
            type: 'menu',
            changeItem: currentMenu,
            isDelete: false
          });
        }
      }
    },
    // 清空控件、行、列选中
    clearComRowColChecked() {
      const needClearArr = ['component', 'row', 'col'];
      needClearArr.forEach(key => {
        const DataMap = this.treeDataObj[key].map(i => ({
          ...i,
          checked: false
        }));
        this.treeDataObj = {
          ...this.treeDataObj,
          [key]: DataMap
        };
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [key]: []
        };
        if (key === 'row') {
          this.originData.row = this.originData.row.map(i => ({ ...i, checked: false }));
        }
      });
    },
    // 保存按钮
    onSelectSubmit({ type }) {
      const { submitMethod: method } = permissionRoleConfig[type];
      this[method](type);
    },
    // 搜索
    onSearchChange({ value, type }) {
      const searchUseData = _.cloneDeep(this.searchUseData[type]);
      let searcheTree = [];
      if (!value) {
        searcheTree = type == 'department' ? util.setSelectIdsByRelationId(searchUseData, this.selectIds[type]) : util.setSelectIds(searchUseData, this.selectIds[type]);
      } else {
        searcheTree = util.treeForSearch(
          searchUseData,
          value,
          this.selectIds[type],
          type == 'department'
        );
      }
      this.treeDataObj = {
        ...this.treeDataObj,
        [type]: searcheTree
      };
    },
    roleCheckChange(type, changeItem) {
      this.changeSelectIdsMap = {
        ...this.changeSelectIdsMap,
        [type]: [changeItem]
      };
      const { clearType } = permissionRoleConfig[type];
      this.submitRole(type).then(async res => {
        if (res) {
          let roleSelectIds = this.selectIds[type];
          if (changeItem.checked) {
            const roleList = this.treeDataObj[type];
            const newList = roleList.map(item => {
              if (item.id === changeItem.id) {
                item.selected = true;
              } else {
                item.selected = false;
              }
              return item;
            });
            this.treeDataObj = {
              ...this.treeDataObj,
              [type]: _.cloneDeep(newList)
            };
            if (this.currentRoleId) {
              await this.systemChange();
            }
            roleSelectIds = [...roleSelectIds, changeItem.id];
            this.currentRoleId = changeItem.id;
            this.clearByType(clearType);
            this.originData.row = [];
            this.originData.systemRow = [];
            // this[method](changeItem.id, nextType);
            // 获取系统行权限数据、菜单权限数据
            // 菜单权限数据
            this.getMenuInfo(this.currentAppId, ['menu']);
            // 获取
            this.getRoleAppRowRule({ appId: this.currentAppId, userId: this.userId, roleId: this.currentRoleId });
          } else {
            roleSelectIds = roleSelectIds.filter(id => id !== changeItem.id);
            if (changeItem.selected) {
              this.clearByType(clearType);
              this.originData.row = [];
              this.originData.systemRow = [];
            }
          }
          this.selectIds = {
            ...this.selectIds,
            [type]: [...new Set(roleSelectIds)]
          };
        } else {
          changeItem.checked = false;
        }
      });
    },
    menuCheckChange(type, changeItem, dtClear = false) {
      const {
        getNextItem: method,
        nextType,
        saveIdName,
        clearType
      } = permissionRoleConfig[type];
      this.submitMenu(type).then(res => {
        if (res) {
          if (changeItem.checked) {
            const selctList = this.treeDataObj[type];
            const newList = util.setItemSelected(selctList, changeItem.id);
            this.treeDataObj = {
              ...this.treeDataObj,
              [type]: _.cloneDeep(newList)
            };
            const saveIdList = ['app', 'menu', 'role'];
            if (saveIdList.includes(type)) {
              this[saveIdName] = changeItem.id;
            }
            if (!dtClear) {
              this.clearByType(clearType);
              this[method](changeItem.id, nextType);
            }
          } else {
            if (changeItem.selected) {
              this.clearByType(clearType);
              this.originData.row = [];
            }
          }
        } else {
          changeItem.checked = false;
        }
      });
    },
    onSelectAll({ type, checkAll }) {
      // 现在只有角色是有全选的，暂时不管其他的了，直接改了，到时候如果其他的也有全选，就通过type区分
      const roleList = this.treeDataObj[type];
      let newList = [];
      newList = roleList.map((item, index) => {
        if (item.id != customDepartmentID) {
          item.checked = checkAll;
        }
        // if (checkAll && index == 0) {
        //   item.selected = true;
        // } else {
        //   item.selected = false;
        // }
        return item;
      });
      this.changeSelectIdsMap = {
        ...this.changeSelectIdsMap,
        [type]: [...newList]
      };
      const { clearType, getNextItem: method, nextType, saveIdName } = permissionRoleConfig[type];
      this.clearByType(clearType);
      this.submitRole(type).then(res => {
        if (res) {
          let roleSelectIds = [];
          if (checkAll) {
            roleSelectIds = newList.map(item => item.id);
            // 获取第一个的授权系统数据
            this[method](newList[0].id, nextType);
          }
          const saveIdList = ['app', 'menu', 'role'];
          if (saveIdList.includes(type)) {
            this[saveIdName] = newList[0].id;
          }
          this.treeDataObj = { ...this.treeDataObj, [type]: _.cloneDeep(newList) };
          this.selectIds = {
            ...this.selectIds,
            [type]: [...roleSelectIds]
          };
        }
      });
    },
    // 部门确定问题
    selectDepartmentSubmit ({ selDepartRelList, type, delSelDepartRelList, allDepartRelList }) {
      const obj = this.treeDataObj[type].find(i => i.id === customDepartmentID) || {};
      let checked = true;
      if (selDepartRelList.length === 0) {
        checked = false;
      }
      if (type === 'row' && checked) {
        const refs = this.$refs.menu[0].getSelectedNodes();
        const changeItem = refs[0];
        if (!changeItem.checked) {
          changeItem.checked = true;
          this.onCheckChange({ type: 'menu', changeItem, isDelete: false, dtClear: true });
        }
      }
      obj.checked = checked;
      obj.selDepartRelList = [...selDepartRelList || []];
      obj.delSelDepartRelList = [...delSelDepartRelList || []];
      obj.allDepartRelList = JSON.parse(JSON.stringify(allDepartRelList || []));
    },
    // 保存全局行权限
    submitSystemRow (type, noFresh = false) {
      return new Promise(resolve => {
        if (!this.rowIsChange(this.originData.systemRow, this.treeDataObj.systemRow)) {
          return this.$Message.error('未变化任何数据');
        }
        const dataRowRuleAuths = this.treeDataObj.systemRow.map(i => {
          return {
            authStatus: i.checked ? 1 : 0,
            delSelDepartRelList: [...i.delSelDepartRelList || []],
            selDepartRelList: [...i.selDepartRelList || []],
            id: i.id
          };
        });
        submitOrgUserRoleApi({ appId: this.currentAppId, dataRowRuleAuths, userId: this.userId, roleId: this.currentRoleId }).then(res => {
          resolve();
          !noFresh && this.getRoleAppRowRule({ appId: this.currentAppId, roleId: this.currentRoleId, userId: this.userId });
        });
      });
    },
    getAppList () {
      getOwnAppInAuthUserListApi().then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          const appAuthorization = data.map(item => ({ id: item.id, title: item.name, needSelected: true }));
          this.treeDataObj = { ...this.treeDataObj, app: appAuthorization };
        }
      });
    },
    // 判断行权限是否发生变化
    rowIsChange (originData, currentData) {
      /**
       * 判断行权限是否发生过变化
       * 1. 先判断外层的 是否发生过变化，如果发生过变化，那么直接返回true就行了
       * 2. 如果外层的没有发生过变化，那么就判断 自定义部门里的有没有发生过变化
       * 2.1 判断自定义部门里面的 selDepartRelList 里面的数据是否一样就行了
       * 3. 如果都没有发生过变化，那么直接返回false
       */
      const isDifferent = this.getDifferentData(originData, currentData);
      // 如果两层不一样，直接返回true。 证明更改过
      if (isDifferent) return true;
      // 如果两层一样，那么再继续判断自定义部门里面的

      const originDepartRelList = (originData.find(i => i.id === customDepartmentID) || {}).selDepartRelList || [];
      const currentDepartRelList = (currentData.find(i => i.id === customDepartmentID) || {}).selDepartRelList || [];
      if (originDepartRelList.length !== currentDepartRelList.length) return true;
      return !currentDepartRelList.every(item => originDepartRelList.includes(item));
    },
    // 判断两个对象是否一样
    getDifferentData (arr1, arr2) {
      const arr1StrArr = arr1.map(item => `${item.checked}_${item.id}`);
      const arr2StrArr = arr2.map(item => `${item.checked}_${item.id}`);
      return !arr1StrArr.every(item => arr2StrArr.includes(item));
    },
    // 系统切换时
    // 先判断页面控件是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面行数据是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面列数据是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面权限数据是否保存，如果没有保存，那么进行询问是否需要保存
    systemChange () {
      return new Promise(resolve => {
        // 判断页面控件是否保存了
        const componentIsChange = this.componentIsChange();
        const colIsChange = this.colIsChange();
        const menuChange = this.menuChange();
        const rowIsChange = this.rowIsChange(this.originData.row, this.treeDataObj.row);
        const appRowIsChange = this.rowIsChange(this.originData.systemRow, this.treeDataObj.systemRow);
        if (componentIsChange || colIsChange || menuChange || rowIsChange || appRowIsChange) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否保存当前系统权限配置变更',
            onOk: async () => {
              if (menuChange) {
                await this.submitMenu('menu');
              }
              if (componentIsChange) {
                await this.ajaxOthers('component');
              }
              if (colIsChange) {
                await this.ajaxOthers('col');
              }
              if (rowIsChange) {
                await this.ajaxOthers('row');
              }
              if (appRowIsChange) {
                await this.submitSystemRow('systemRow', true);
              }
              resolve(true);
            },
            onCancel: () => {
              resolve(true);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    componentIsChange () {
      const data = this.changeSelectIdsMap.component;
      return data.length > 0;
    },
    colIsChange () {
      const data = this.changeSelectIdsMap.col;
      return data.length > 0;
    },
    menuChange () {
      const data = this.changeSelectIdsMap.menu;
      return data.length > 0;
    },
    menuTreePromise () {
      return new Promise(resolve => {
        const colIsChange = this.colIsChange();
        const componentIsChange = this.componentIsChange();
        const rowIsChange = this.rowIsChange(this.originData.row, this.treeDataObj.row);
        const menuChange = this.menuChange();
        if (colIsChange || componentIsChange || rowIsChange || menuChange) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否保存当前系统权限配置变更',
            onOk: async () => {
              if (menuChange) {
                await this.submitMenu('menu');
              }
              if (componentIsChange) {
                await this.ajaxOthers('component');
              }
              if (colIsChange) {
                await this.ajaxOthers('col');
              }
              if (rowIsChange) {
                await this.ajaxOthers('row');
              }
              resolve(true);
            },
            onCancel: () => {
              resolve(true);
            }
          });
        } else {
          resolve();
        }
      });
    },
    async menuTreeChange (selectItem) {
      if (this.currentMenuId) {
        await this.menuTreePromise();
      }
      const { id } = selectItem;
      this.currentMenuId = id;
      const { getNextItem: method, nextType, clearType } = getConfigByType.menu || {};
      this[method](id, nextType, clearType);
    }
  },
  created() {
    /**
     * 2024/2/20 新逻辑
     * 先选择系统，然后选择不同系统的角色
     * 之后就之前的逻辑，还是选择菜单 控件，行列数据，但是自定义部门也更改了
     */
    this.getAppList();
    // this.getRoleList();
  }
};
</script>
<style lang="less" scoped>
.permissionMain {
  display: flex;
  height: 400px;
  overflow-x: auto;
  background-color: #eee;
  .serPermissions {
    height: 100%;
    overflow-y: auto;
  }
}
.myViewItem {
  width: 30%;
}
.myViewItem /deep/ .view-item-label {
  font-size: 14px;
}
</style>
